Drupal.behaviors.sw_gtm = {
  attach: function( context, settings ) {
    $(once('sw_gtm', '.js-gtm-event', context)).each(function() {

      const $w = $(this);
      const event = $w.data('gtm-event');
      const event_data = $w.data('gtm-data');
      if ( event ) {
        sw_gtm_event ( event, event_data );
      }

    });
  }
}

// Ajax command
Drupal.AjaxCommands.prototype.sw_gtm_event = function (ajax, response, status) {
  const event = response.event
  const event_data = response.data;
  sw_gtm_event ( event, event_data );
}

let sw_gtm_page_commands = [];

/**
 * Fires an event, and show debug
 *
 * @param event
 * @param event_data
 */
function sw_gtm_event ( event, event_data ) {
  // Run each even only once per page.
  if ( sw_gtm_page_commands.includes( event ) ) {
    return;
  }
  sw_gtm_page_commands.push( event );
  console.log('sw gtm', event, event_data);
  if ( typeof gtag !== 'undefined' ) {
    gtag('event', event, event_data);
  }
}
